import {queryOptions, useMutation, useQueryClient} from '@tanstack/react-query';
import {api, apiJson} from './client';

export interface DriveStatus {
  connected: boolean;
  connectedAs: string | null;
  connectedAt: string | null;
  rootFolderId: string | null;
  rootFolderName: string | null;
}

export const driveStatusQueryOptions = queryOptions({
  queryKey: ['admin', 'google', 'status'],
  queryFn: () => api<DriveStatus>('/admin/google/status'),
});

export function useDisconnectDrive() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiJson<{ok: true}>('/admin/google/disconnect', {}),
    onSuccess: () => qc.invalidateQueries({queryKey: driveStatusQueryOptions.queryKey}),
  });
}
